import * as S from './style';

export default function SkeletonRankingCard() {
  return (
    <S.SkelletonCard>
      <div className='rank'></div>
      <div className='logo'></div>
      <div className='companyInfo'>
        <p></p>
        <p></p>
      </div>
      <div className='data'></div>
    </S.SkelletonCard>
  );
}
